import {
  Component,
  input,
  output,
  signal,
  HostListener,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { TPipe } from '../../pipes/t.pipe';

@Component({
  selector: 'app-list-settings-popover',
  standalone: true,
  imports: [LucideAngularModule, TPipe],
  templateUrl: './list-settings-popover.component.html',
  host: { class: 'relative block' },
})
export class ListSettingsPopoverComponent {
  private readonly el = inject(ElementRef<HTMLElement>);

  /** Se o usuário é admin (habilita Permissões) */
  isAdmin = input<boolean>(false);
  /** Só **Admin** da empresa (não Owner): ordenação nativos + custom via API. */
  canManageCardFieldDisplayOrder = input<boolean>(false);
  /** Toggle "Mostrar itens fechados" (mock) */
  canManageWhatsAppService = input<boolean>(false);
  showClosedItems = input<boolean>(false);
  showClosedItemsChange = output<boolean>();

  isOpen = signal(false);
  panelRef = viewChild<ElementRef<HTMLElement>>('panel');

  openManageStatus = output<void>();
  openCustomFields = output<void>();
  openDisplayFields = output<void>();
  openCardFieldDisplayOrder = output<void>();
  openProcessMembers = output<void>();
  openWhatsAppService = output<void>();

  toggle(): void {
    this.isOpen.update((v) => !v);
  }

  close(): void {
    this.isOpen.set(false);
  }

  onShowClosedChange(checked: boolean): void {
    this.showClosedItemsChange.emit(checked);
  }

  onManageStatus(): void {
    this.close();
    this.openManageStatus.emit();
  }

  onCustomFields(): void {
    this.close();
    this.openCustomFields.emit();
  }

  onDisplayFields(): void {
    this.close();
    this.openDisplayFields.emit();
  }

  onCardFieldDisplayOrder(): void {
    this.close();
    this.openCardFieldDisplayOrder.emit();
  }

  onWhatsAppService(): void {
    if (!this.canManageWhatsAppService()) return;
    this.close();
    this.openWhatsAppService.emit();
  }

  onProcessMembers(): void {
    this.close();
    this.openProcessMembers.emit();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen()) return;
    const target = event.target as Node;
    if (!this.el.nativeElement.contains(target)) {
      this.close();
    }
  }
}
